export default {"src":"/_next/static/media/ela.1536afaa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};